/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

interface IAccountWishlistTileDescription {
    description: string;
}

const IAccountWishlistTileDescription: React.FC<IAccountWishlistTileDescription> = ({ description }) => (
    <p className='ms-account-wishlist-tile__description'>{description}</p>
);

export default IAccountWishlistTileDescription;
